// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__tZjCj","author":"Table_author__12cU_","authorImage":"Table_authorImage__2iG_i","unreadRow":"Table_unreadRow__1EegO"};